import creditCardType from 'credit-card-type';
import binlookup from 'binlookup';

const CreditCard = {
    mask: (ccNumberStr) => `************ ${ccNumberStr.substr(-4)}`,
    ccType: (num) => {
        const ccLogos = ['visa', 'mastercard', 'american-express', 'discover'];
        const card = creditCardType(num);
        if (num !== '' && card[0] && card[0].type && ccLogos.indexOf(card[0].type) > -1) {
            return card[0].type;
        }
        return 'generic';
    },
    getBinLookupInfo: (cardNum) => {
        if (!cardNum || cardNum === '') return Promise.resolve({});
        const noSpaceCardNum = cardNum.trim().replaceAll(' ', '');
        const NUM_OF_DIGITS_TO_SEND = 6;
        if (noSpaceCardNum.length >= NUM_OF_DIGITS_TO_SEND) {
            const binLookupService = binlookup();
            return binLookupService(noSpaceCardNum.slice(0, NUM_OF_DIGITS_TO_SEND));
        }
        return Promise.resolve({});
    },
};

export default CreditCard;



/** WEBPACK FOOTER **
 ** ./src/services/credit-card.js
 **/